import DispensaryProductPage from 'src/dispensary/product';
import { DispensaryProductLayout } from 'src/components/layouts/dispensary-product-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(DispensaryProductPage, DispensaryProductLayout);
